export default import.meta.ROLLDOWN_FILE_URL_ElF$v0mvEldx1q5Hjg023Q